<template>
  <span>{{ maximaFechaCompromiso }}</span>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "maximaFechaDeCompromiso",
  computed: {
    maximaFechaCompromiso() {
      if (this.params.data.maximaFechaDeCompromiso)
        return this.$moment(this.params.data.maximaFechaDeCompromiso).format(
          "ddd DD/MM/YYYY",
        );
      return "";
    },
  },
});
</script>
